import { ENVIRONMENT } from '@evc/platform';

export const baseEnvironment = {
  production: true,
  // USE_CONNECT_PLATFORM: true,
  USE_CONNECT_PLATFORM: window.location.host.startsWith('vdv.'),
  EVC_REDIRECT_URL: 'https://vdv.connect.evidentscientific.com/',
  ENV: ENVIRONMENT.production,
  AUTH_CLIENT_ID: '1ffd4be8-9a5e-4e6f-95d4-3916bbf8fc8b',
  PROTECTED_URIS: {
    VANTAAPP: "https://vdv.connect.evidentscientific.com/api/",
  },
  DEVICE_API_URL: "https://device.api.ca.connect.evidentscientific.com"
};
